import React from 'react';
import { InputTextarea } from 'primereact/inputtextarea';
import {
    NotesContainer,
    CardHeader,
    ContentBody,
    CardFooter,
} from './Notes.styled';

const Notes = (props) => {
    const {
        helperText,
        helperTextFont,
        title,
        note,
        updateNotes,
        width,
        height,
        backGround,
        boxShadow,
        borderRadius,
        border,
        margin,
        cardHeaderMargin,
        contentBodyMargin,
        contentBodyBackground,
        cardFooterMargin,
        justifyContent,
        textAreaWidth,
        textAreaBorderRadius,
        placeholderHeight,
        placeholderFont,
        placeholderFontFamily,
        moblieWidth,
        ipadWidth,
        rows,
        cols,
        fontSize,
        maxLength,
        autoResize,
        isScrollBar,
        isTextAreaResize,
        handleFocus,
        onKeyPress,
        placeholder,
        id,
        textAreaBorder,
        textAreaHeight,
        textAreaDisabled,
        placeholderFontColor,
        textAreaId,
        padding,
        lineHeight,
        showAstrisk,
        helperTextPositionTop,
    } = props;

    const renderHelperText = () => (
        <CardFooter
            cardFooterMargin={cardFooterMargin}
            justifyContent={justifyContent}
            helperTextFont={helperTextFont}
        >
            <div className="helpertext-content">{helperText}</div>
        </CardFooter>
    );

    return (
        <>
            <NotesContainer
                id={id}
                width={width}
                height={height}
                backGround={backGround}
                borderRadius={borderRadius}
                border={border}
                margin={margin}
                boxShadow={boxShadow}
                moblieWidth={moblieWidth}
                ipadWidth={ipadWidth}
            >
                <CardHeader
                    cardHeaderMargin={cardHeaderMargin}
                    fontSize={fontSize}
                    showAstrisk={showAstrisk}
                >
                    {title}
                </CardHeader>
                {helperTextPositionTop && renderHelperText()}
                <ContentBody
                    contentBodyMargin={contentBodyMargin}
                    contentBodyBackground={contentBodyBackground}
                    textAreaWidth={textAreaWidth}
                    textAreaBorderRadius={textAreaBorderRadius}
                    isScrollBar={isScrollBar}
                    isTextAreaResize={isTextAreaResize}
                    placeholderHeight={placeholderHeight}
                    placeholderFont={placeholderFont}
                    placeholderFontFamily={placeholderFontFamily}
                    scrollBarBackgroundColor={'#888'}
                    scrollBarTrachBackGroundColor={'#f1f1f1'}
                    scrollBarBorderRadius={'0'}
                    scrollBarBackGroundColorOnHover={'#555'}
                    textAreaBorder={textAreaBorder}
                    textAreaHeight={textAreaHeight}
                    placeholderFontColor={placeholderFontColor}
                    lineHeight={lineHeight}
                >
                    <InputTextarea
                        className="common-notes-input-dt-mask"
                        value={note}
                        onChange={(e) => updateNotes(e.target.value)}
                        onFocus={handleFocus}
                        rows={rows}
                        cols={cols}
                        style={{ width: '100%' , padding}}
                        autoResize={autoResize}
                        maxLength={maxLength}
                        onKeyPress={onKeyPress}
                        placeholder={placeholder}
                        disabled={textAreaDisabled}
                        id={textAreaId}
                    />
                </ContentBody>
                {!helperTextPositionTop && renderHelperText()}
            </NotesContainer>
        </>
    );
};

Notes.defaultProps = {
    width: '100%',
    height: '100%',
    backGround: '#ffffff 0% 0% no-repeat padding-box',
    boxShadow: '0px 0px 6px #00000029',
    borderRadius: '6px',
    border: 'none',
    margin: '0px 10px 0px 0px',
    cardHeaderMargin: '14px 0px 0px 23px',
    contentBodyMargin: '13px 23px 0px 23px',
    contentBodyBackground: '#ffffff 0% 0% no-repeat padding-box',
    cardFooterMargin: '8px 0px 24px 23px',
    textAreaWidth: 'unset',
    textAreaBorderRadius: 'unset',
    placeholderHeight: 'unset',
    placeholderFont: 'unset',
    rows: 3,
    cols: 30,
};
export default Notes;
